import { useIntl } from "react-intl";
import { DetailsField } from "components/DetailsField";
import { HistoryDetailsAutoswapProps } from "./types";
import { messages } from "./messages";
import { useFormatter } from "hooks/utils/useFormatter";
import { RULE_EVENT_ID, SWAP_STATUS } from "@letsbit/malcolmlb";

export const HistoryDetailsAutoswap: React.FC<HistoryDetailsAutoswapProps> = ({
  data: autoswap,
}) => {
  const { formatMessage } = useIntl();
  const { formatValue } = useFormatter();

  const getStatus = (state?: string) => {
    let stClass = "text-[--color-warning]";
    let st = formatMessage(messages.statusInProgress);

    switch (state) {
      case SWAP_STATUS.SUCCEED:
        stClass = "text-[--color-success]";
        st = formatMessage(messages.approved);
        break;
      case "failed":
        stClass = "text-[--color-error]";
        st = formatMessage(messages.rejected);
        break;
    }
    return <span className={stClass}>{st}</span>;
  };
  return (
    <div className="flex flex-col gap-y-6">
      <DetailsField label={""} value={formatMessage(messages.autoswap)} />
      <DetailsField
        label={formatMessage(messages.event)}
        value={`${
          autoswap.extra_data.kind === RULE_EVENT_ID.DEPOSITS
            ? formatMessage(messages.autoswapDeposit)
            : autoswap.extra_data.kind === RULE_EVENT_ID.CASHBACK
              ? formatMessage(messages.autoswapChasback)
              : formatMessage(messages.autoswapInvest)
        } ${autoswap.extra_data.out_currency_ticker_id?.toUpperCase()}`}
      />
      <DetailsField
        label={formatMessage(messages.convertTo)}
        value={`${formatValue(
          autoswap.extra_data.percentage || "",
        )}% a ${autoswap.ticker_id?.toUpperCase()} `}
      />
      <DetailsField
        label={formatMessage(messages.adjustmentAmount)}
        value={`- ${formatValue(
          autoswap.extra_data.spent || "",
          autoswap.extra_data.out_currency_precision,
        )} ${autoswap.extra_data.out_currency_ticker_id?.toUpperCase()}`}
      />
      <DetailsField
        label={formatMessage(messages.convertTo)}
        value={`${formatValue(
          autoswap.amount,
          autoswap.precision,
        )} ${autoswap.ticker_id?.toUpperCase()} `}
      />
      <DetailsField
        label={formatMessage(messages.status)}
        value={getStatus(autoswap.extra_data.state)}
      />
      <DetailsField
        label={formatMessage(messages.movementId)}
        value={autoswap.tid ?? ""}
        copy
      />
    </div>
  );
};
